var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"#102a63","dark":"","height":"80px"}},[_c('v-row',[_c('v-col',{attrs:{"lg":"8"}},[_c('img',{staticClass:"logoBaps",attrs:{"src":require("../assets/logo.svg")}}),_c('v-spacer')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }